import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    number: '01',
    title: 'BONO 1 — Calculadora de Costos y Precios',
    description: 'Nunca más vendas a pérdida. Calculá exactamente cuánto te cuesta cada vela y cuánto tenés que cobrar para ganar dinero de verdad. Plantilla lista para usar.',
    value: '$5.000'
  }, {
    number: '02',
    title: 'BONO 2 — Fotografía y Ventas en Instagram',
    description: 'Con tu celular y luz natural podés sacar fotos que venden. Guía paso a paso para mostrar tus velas de forma profesional y atraer clientes.',
    value: '$5.000'
  }, {
    number: '03',
    title: 'BONO 3 — Packaging y Presentación Premium',
    description: 'Cómo presentar, empaquetar y entregar tus velas para que el cliente sienta que recibió algo de lujo. Incluye ideas para etiquetas y presentación de regalo.',
    value: '$5.000'
  }];
  return <section className="w-full bg-neutral-950 py-4 md:py-8" data-id="element-14">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold text-amber-50 text-center mb-3 md:mb-6" data-id="element-17">
            🎁 3 BONOS ESTRATÉGICOS — SIEMPRE INCLUIDOS
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4 mb-3 md:mb-5" data-id="element-18">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-neutral-900 border border-amber-900/40 rounded-lg p-4" data-id="element-19">
                <div className="flex items-start gap-2 mb-2" data-id="element-20">
                  <GiftIcon className="w-5 h-5 text-amber-400 flex-shrink-0" data-id="element-21" />
                  <span className="text-sm font-bold text-amber-400" data-id="element-22">
                    #{bonus.number}
                  </span>
                </div>
                <h3 className="text-base font-bold text-amber-50 mb-2" data-id="element-23">
                  {bonus.title}
                </h3>
                <p className="text-neutral-300 text-sm mb-3 leading-relaxed" data-id="element-24">
                  {bonus.description}
                </p>
                <div className="flex items-center gap-2" data-id="element-25">
                  <span className="text-neutral-500 line-through text-sm" data-id="element-26">
                    {bonus.value}
                  </span>
                  <span className="text-amber-400 font-bold text-sm" data-id="element-27">
                    GRATIS
                  </span>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center" data-id="element-28">
            <p className="text-lg md:text-xl font-bold text-amber-50" data-id="element-29">
              Valor total de los bonos:{' '}
              <span className="line-through text-neutral-500" data-id="element-30">$15.000</span>
              {' → '}
              <span className="text-amber-400" data-id="element-31">GRATIS con tu Mega Pack</span>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}